import * as React from "react";
const SvgHome = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgHome as ReactComponent };